import { useState, useEffect } from "react";
import { collection, getDocs, onSnapshot } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useAuth } from "../context/AuthContext";
import { dayOffDates } from "./dayOffModel";

// Custom hook to fetch staff from Firebase
export const useStaffList = () => {
  const [staffList,setStaffList]=useState([]);
  const {currentUser}=useAuth();
  useEffect(()=>{
    let active=true,unsubscribe;setStaffList([]);
    if(!currentUser)return;
    getDocs(collection(db,"staff")).then(snapshot=>{
      if(!active)return;
      const source=collection(db,"staff_day_off");
      unsubscribe=onSnapshot(source,days=>{
        if(!active)return;
        const documents=days.docs;
        const byId=new Map(documents.map(item=>[item.id,item.data()]));
        setStaffList(snapshot.docs.map(item=>{const data=item.data();return {id:item.id,nickname:data.nickname || "",availability:data.availability || [],role:data.role || "",dayOffRequests:dayOffDates(byId.get(item.id)?.dayOffRequests || data.dayOffRequests)};}));
      },()=>{if(active)setStaffList(snapshot.docs.map(item=>({id:item.id,nickname:item.data().nickname || "",availability:item.data().availability || [],role:item.data().role || "",dayOffRequests:[]})));});
    }).catch(error=>console.error("Error fetching staff:",error));
    return ()=>{active=false;unsubscribe?.();};
  },[currentUser]);
  return staffList;
};

